import styles from './styles.module.scss';

interface MessageBoxProps extends React.HTMLAttributes<HTMLDivElement> {
    content: string;
    showMessageBox: React.ComponentState;
    onPress?: React.MouseEventHandler<HTMLDivElement>;
}

export const MessageBox = ({ content, showMessageBox, onPress, className }: MessageBoxProps) => {
    return (
        <div data-open={showMessageBox} className={`${styles.wrapper} ${className}`}>
            <div className={styles.wrapperInner}>
                <div className={styles.contentBox} dangerouslySetInnerHTML={{ __html: content }} />
                <div className={styles.btnBox}>
                    <div className={`${styles.commonButton} ${styles.button}`} onClick={onPress}>
                        <div className={`fa fa-check`} />
                    </div>
                </div>
            </div>
        </div>
    );
};
